/**
 * This script is added in index.html 's body.
 *
 */

import './_devScripts/vwoDebugger';

// @ts-ignore
document.getCookie = function (cname) {
	var name = cname + '=',
		ca = document.cookie.split(';'),
		cookieValue:string|null = null;
	ca[0] = ' ' + ca[0];
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c && c.charAt(0) === ' ') {
			c = c.substring(1);
			if (c.indexOf(name) === 0) {
				cookieValue = c.substring(name.length, c.length);
			}
		}
	}
	return cookieValue;
};

if (import.meta.env.DEV) {
	window.__isVwoLocalServer = true;
	import('_devScripts/CORSCheck').then(m => m.checkCORSError());
}

window.appVersion = __APP_VERSION__;

//TODO: load editor-vendor css: [
//     "editor/vendor/libraries/jpicker/css/jPicker-1.1.6.css",
//     "styles/codemirror.css"
// ],
